import React from 'react';
import { useSelector } from 'react-redux';
import { BackdropCircular } from 'components';
import Features from './AdditionalFeatures/Features';
import Specials from './AdditionalSpecials/Specials';
import Skus from './AdditionalSkus/Skus';
import SubscriptionPeriodBenefits from './SubscriptionPeriodBenefits';


const Marketing = () => {
  const {
    isLoadingAdditionalFeatures,
    isLoadingAdditionalSkus,
    isLoadingAdditionalSpecials
  } = useSelector((state) => state.subscription);
  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <Skus />
      <Specials />
      <Features />
      <SubscriptionPeriodBenefits />
      <BackdropCircular loading={isLoadingAdditionalFeatures || isLoadingAdditionalSkus || isLoadingAdditionalSpecials} />
    </div>
  );
};

export default Marketing;
